module.exports = __webpack_public_path__ + "static/media/pic-svg-30.cb07fe02.svg";